import { render, staticRenderFns } from "./ReviewCategories.vue?vue&type=template&id=0a855b08&"
import script from "./ReviewCategories.vue?vue&type=script&lang=ts&"
export * from "./ReviewCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports